import { render, staticRenderFns } from "./CookiePrompt.vue?vue&type=template&id=28f4cf50"
import script from "./CookiePrompt.vue?vue&type=script&lang=ts"
export * from "./CookiePrompt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports